import React, { useState } from 'react'
import { Box, Flex, FormControl, FormLabel, Select, Button } from '@chakra-ui/react'
import { ArtGallery } from './components/ArtGallery'
import { useQuery } from 'react-query'

export function BibliotecaDeArtes() {
  const [categoria, setCategoria] = useState('')
  const [tema, setTema] = useState('')
  const [showResults, setShowResults] = useState(false)

  const { data: categorias = [] } = useQuery('categories', async () => {
    return [
      { id: 1, value: 'abstract', label: 'Abstrato' },
      { id: 2, value: 'floral', label: 'Floral' },
      { id: 3, value: 'geometric', label: 'Geométrico' },
      { id: 4, value: 'urban', label: 'Urbano' },
      { id: 5, value: 'dogs', label: 'Dogs' },
    ]
  })

  const { data: temas = [] } = useQuery('themes', async () => {
    return [
      { id: 1, value: 'estilizado', label: 'Estilizado' },
      { id: 2, value: 'minimalista', label: 'Minimalista' },
      { id: 3, value: 'colorido', label: 'Colorido' },
      { id: 4, value: 'neon', label: 'Neon' },
    ]
  })

  const handleCategoriaChange = (e) => setCategoria(e.target.value)
  const handleTemaChange = (e) => setTema(e.target.value)

  const handleMostrarArtes = () => {
    setShowResults(true)
  }

  return (
    <Box>
      <Box borderWidth="1px" borderRadius="lg" p={6} bg="white" borderColor="#F0F0F0" mb={6}>
        <Flex gap={4} alignItems="flex-end" direction={{ base: 'column', md: 'row' }}>
          <FormControl flex="1">
            <FormLabel>Categoria</FormLabel>
            <Select
              placeholder="Escolha a categoria"
              value={categoria}
              onChange={handleCategoriaChange}
              borderColor="#378BBF"
              _focus={{ borderColor: '#378BBF' }}
              size="md"
            >
              {categorias.map((cat) => (
                <option key={cat.id} value={cat.value}>
                  {cat.label}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl flex="1">
            <FormLabel>Tema da Linha</FormLabel>
            <Select
              placeholder="Qual o tema da arte?"
              value={tema}
              onChange={handleTemaChange}
              borderColor="#378BBF"
              _focus={{ borderColor: '#378BBF' }}
              size="md"
            >
              {temas.map((t) => (
                <option key={t.id} value={t.value}>
                  {t.label}
                </option>
              ))}
            </Select>
          </FormControl>

          <Button
            onClick={handleMostrarArtes}
            bg="#378BBF"
            color="white"
            _hover={{ bg: '#2a6a8f' }}
            _active={{ bg: '#1d4d6b' }}
            px={8}
            height="40px"
            minW="160px"
          >
            Mostrar Artes
          </Button>
        </Flex>
      </Box>

      {showResults && <ArtGallery categoria={categoria} tema={tema} />}
    </Box>
  )
}
